import "../../styles/Unauthenticated.scss";

import { ReactComponent as FlickLogo } from "@flick/front_end_patterns/src/images/flick_logo_2021.svg";
import { NotificationBanner } from "components/NotificationBanner";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Navigate } from "react-router";
import { Link } from "react-router-dom";
import { useAppSelector } from "reduxUtils/hook";

type SplashPageProps = {
  login: () => void;
  isAuthenticated: boolean;
  nativeRenderMode: boolean;
};

export const SplashPage: React.FC<SplashPageProps> = ({
  login,
  isAuthenticated,
  nativeRenderMode,
}) => {
  const notificationBanner = useAppSelector(
    (store) => store.notificationBanner,
  );

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Helmet>
        <body className={"background--black background--spotted"} />
      </Helmet>
      <section className="unauthenticated__container unauthenticated__container--inverse">
        <FlickLogo className="unauthenticated__logo unauthenticated__logo--yellow" />
        {notificationBanner && (
          <div className="unauthenticated__notification_container">
            <NotificationBanner />
          </div>
        )}
        <h2 className="unauthenticated__tagline">You've got the power!</h2>
        <button
          className="unauthenticated__button unauthenticated__button--primary"
          onClick={login}
        >
          Log in
        </button>
        {nativeRenderMode && (
          <>
            <p className="unauthenticated__prompt">
              Want to track prices and carbon emissions without an account?
            </p>
            <Link
              to="/"
              className="unauthenticated__button unauthenticated__button--dark"
            >
              Take a look
            </Link>
          </>
        )}
      </section>
    </>
  );
};
